<template>
	<AppModal v-bind="$attrs" class="qr-code-modal">
		<div class="qr-code-modal__content text-center">
			<img v-if="qrCode" :src="qrCode" alt="" />
		</div>
	</AppModal>
</template>

<script>
import AppModal from '@/components/landing/AppModal.vue'

export default {
	name: 'CharacterModal',
	components: {
		AppModal
	},
	props: {
		qrCode: {
			type: String
		}
	}
}
</script>
